import { render, staticRenderFns } from "./ImagesManagement.vue?vue&type=template&id=4542c377&"
import script from "./ImagesManagement.vue?vue&type=script&lang=js&"
export * from "./ImagesManagement.vue?vue&type=script&lang=js&"
import style0 from "./ImagesManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports